import { Estimations } from "./../types/estimation.type";
import { Image, ImageLabelData } from "./../types/Image.type";
import { Pagination, PaginationScroll } from "./../types/pagination.type";
import { responseHandlerDefault } from "./../utils/handler.util";
import axios from "./api";
import { Filter } from "@/types/filter.type";

export const getLastImageWithParameters = (
  samplingPointId: number,
  code?: string | undefined
): Promise<Estimations> => {
  return axios
    .get<Estimations>(`/image/last?samplingPoint=${samplingPointId}&code=${code}`)
    .then(responseHandlerDefault);
};

export const getLastImageStation = (
  codeStation: string,
  codeCamera: string | undefined,
  numCamera: number | undefined
): Promise<Image | undefined> => {
  const params: { codecamera?: string; numcamera?: number } = {};
  if (codeCamera) {
    params.codecamera = codeCamera;
  }
  if (numCamera) {
    params.numcamera = numCamera;
  }

  return axios.get(`/image/lastimage/${codeStation}`, { params }).then(responseHandlerDefault);
};

/**
 * get last images
 * @param stationId
 * @param page
 * @param size
 * @returns
 */
export const getLastImages = (
  stationId: string,
  page = 1,
  size = 10,
  camera?: string | undefined
): Promise<Pagination<Image>> => {
  const params: { page?: number; size?: number; camera?: string } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }

  if (camera) {
    params.camera = camera;
  }

  return axios.get(`/image/getLastImages/${stationId}`, { params }).then(responseHandlerDefault);
};

export const getImagesDates = (stationId: string): Promise<{ data: { image_date: string }[] }> => {
  return axios.get(`/image/getImagesDates/${stationId}`).then(responseHandlerDefault);
};
/**
 * get last images
 * @param stationId
 * @param page
 * @param size
 * @param fromDate
 * @param toDate
 * @returns
 */
export const getLastImagesByDate = (
  stationId: string,
  page = 1,
  size = 10,
  camera?: string | undefined,
  fromDate?: Date | undefined,
  toDate?: Date | undefined,
  type?: string | undefined
): Promise<Pagination<Image>> => {
  const params: {
    type?: string;
    page?: number;
    size?: number;
    camera?: string;
    fromDate?: string;
    toDate?: string;
  } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }

  if (camera) {
    params.camera = camera;
  }
  if (fromDate) {
    params.fromDate = fromDate.toISOString();
  }
  if (toDate) {
    params.toDate = toDate.toISOString();
  }
  if (type) {
    params.type = type;
  }

  return axios
    .get(`/image/getLastImagesByDate/${stationId}`, { params })
    .then(responseHandlerDefault);
};

/**
 * get image
 * @param file
 * @param thumbnail
 * @returns
 */
export const getImage = (file: string, thumbnail = true): Promise<string> => {
  return axios
    .get(`/image/${thumbnail ? "file-thumbnail" : "file"}${file}`, { responseType: "blob" })
    .then((res) => {
      return URL.createObjectURL(responseHandlerDefault(res));
    });
};
/**
 * get image tmoa
 * @param file
 * @returns
 */
export const getImageTmoa = (file: string): Promise<string> => {
  return axios.get(`/image/file-thumbnail-tmoa/${file}`, { responseType: "blob" }).then((res) => {
    return URL.createObjectURL(responseHandlerDefault(res));
  });
};

export const getSamplingPointImages = (
  samPointId: string,
  page = 1,
  size = 10,
  startDateTime?: string,
  endDateTime?: string
): Promise<Pagination<Image>> => {
  const params: { page?: number; size?: number; startDateTime?: string; endDateTime?: string } = {};

  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (startDateTime) {
    params.startDateTime = startDateTime;
  }
  if (endDateTime) {
    params.endDateTime = endDateTime;
  }

  return axios
    .get(`/image/getLastImagesPoint/${samPointId}`, { params })
    .then(responseHandlerDefault);
};

/**
 * Ontener imágenes para etiquetar
 * @param samPointId
 * @param page
 * @param size
 * @param startDateTime
 * @param endDateTime
 * @returns
 */
export const getSamplingPointImagesLabel = (
  samPointId: string,
  page: number,
  size: number,
  startDateTime?: string,
  endDateTime?: string,
  tmoaId?: number,
  cameras?: string[],
  filterImages?: Filter
): Promise<PaginationScroll<ImageLabelData>> => {
  const params: {
    page?: number;
    size?: number;
    startDateTime?: string;
    endDateTime?: string;
    tmoa?: number;
    cameras?: string[];
    filter?: Filter;
  } = {};

  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (startDateTime) {
    params.startDateTime = startDateTime;
  }
  if (endDateTime) {
    params.endDateTime = endDateTime;
  }

  if (tmoaId) {
    params.tmoa = tmoaId;
  }
  if (cameras) {
    params.cameras = cameras;
  }

  if (filterImages) {
    params.filter = filterImages;
  }
  return axios.get(`/image/getImagesLabel/${samPointId}`, { params }).then(responseHandlerDefault);
};

export const getImageGraph = (station: string, dateTime: Date): Promise<Image> => {
  const params: { station: string; dateTime: string } = {
    station: station,
    dateTime: dateTime.toISOString(),
  };
  return axios.get(`/image`, { params }).then(responseHandlerDefault);
};

export const getImageByFile = (fileName: string): Promise<Image> => {
  const params: { fileName: string } = {
    fileName: fileName,
  };
  return axios.get(`/image/imageByFile`, { params }).then(responseHandlerDefault);
};
export const getImageById = (id: number): Promise<Image> => {
  const params: { id: number } = {
    id: id,
  };
  return axios.get(`/image/imageById`, { params }).then(responseHandlerDefault);
};

export const sendManualImage = (data: unknown, station: string): Promise<unknown> => {
  if (!station) {
    throw new Error("station is required");
  }

  return axios
    .post(`/image/addManual/${station}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(responseHandlerDefault);
};

export const downloadImages = (
  //server: string,
  nameZip: string
): Promise<any> => {
  const params: { name: string } = { name: nameZip };

  return axios
    .get(`/image/downloadImages`, { params, responseType: "arraybuffer" })
    .then(responseHandlerDefault);
};

export const generateZip = (
  samplingPoint: string,
  camera: string,
  labelling: string,
  fromDate: Date,
  toDate: Date
): Promise<string> => {
  const params: {
    //server: string;
    samplingPoint: string;
    camera: string;
    labelling: string;
    fromDate: string;
    toDate: string;
  } = {
    //server: server,
    samplingPoint: samplingPoint,
    camera: camera,
    labelling: labelling,
    fromDate: fromDate.toISOString(),
    toDate: toDate.toISOString(),
  };
  return axios.get(`/image/generateZip`, { params }).then(responseHandlerDefault);
};

export const generateThumbnailZip = (
  samplingPoint: string,
  name: string,
  fromDate: Date,
  toDate: Date,
  camera?: string,
  labelling?: string
): Promise<string> => {
  const params: {
    samplingPoint: string;
    name: string;
    fromDate: string;
    toDate: string;
    camera?: string;
    labelling?: string;
  } = {
    samplingPoint: samplingPoint,
    name: name,
    fromDate: fromDate.toISOString(),
    toDate: toDate.toISOString(),
  };

  if (camera) {
    params.camera = camera;
  }

  if (labelling) {
    params.labelling = labelling;
  }

  return axios.get(`/image/generateThumbnailZip`, { params }).then(responseHandlerDefault);
};

export const downloadThumbnails = (nameZip: string): Promise<any> => {
  const params: { name: string } = { name: nameZip };

  return axios
    .get(`/image/downloadThumbnails`, { params, responseType: "arraybuffer" })
    .then(responseHandlerDefault);
};

export const getDistinctLevelsImage = (samplinPoint: number): Promise<string[]> => {
  return axios.get(`/image/level/${samplinPoint}`).then(responseHandlerDefault);
};

export const updateExpertLevel = (image: Image): Promise<Image> => {
  return axios.put<Image>(`/image/expertlevel/${image.id}`, image).then(responseHandlerDefault);
};

/**
 * Vincular una imagen con training data
 * @param imageId
 * @param sinteticos ids de trainingData sintéticos
 * @param organicos ids de trainingData orgánicos
 */
export const addImageTrainingRelations = (
  imageId: number,
  sinteticos: number[],
  organicos: number[]
): Promise<any> => {
  return axios
    .post(`/image/${imageId}/training-relations`, { sinteticos, organicos })
    .then(responseHandlerDefault);
};

export const addImageTrainingRelationsMassive = (
  imageId: number,
  sinteticos: number[],
  organicos: number[]
): Promise<any> => {
  return axios
    .post(`/image/${imageId}/training-relations-massive`, { sinteticos, organicos })
    .then(responseHandlerDefault);
};

export const getImageTrainingRelations = (imageId: number) => {
  return axios.get(`/image/${imageId}/training-relations`).then(responseHandlerDefault);
};

export const getImageTrainingRelationsLabel = (imageId: number) => {
  return axios.get(`/image/${imageId}/training-relations-label`).then(responseHandlerDefault);
};

//-
export const getImagesByDateIncremental = (
  stationId: string,
  fromDate?: string,
  strict?: boolean,
  camera?: string,
  toDate?: string,
  type?: string,
  origin?: string | "STATION"
): Promise<Image[]> => {
  const params: any = { strict };
  if (fromDate) params.fromDate = fromDate;
  if (camera) params.camera = camera;
  if (toDate) params.toDate = toDate;
  if (type) params.type = type;
  if (origin) params.origin = origin;

  return axios
    .get(`/image/getImagesByDateIncremental/${stationId}`, { params })
    .then(responseHandlerDefault);
};

export const updateDayOrNight = (image: Image): Promise<Image> => {
  return axios.put<Image>(`/image/dayOrNight/${image.id}`, image).then(responseHandlerDefault);
};

export const updateDayOrNightHistorical = (
  samplingPoint: number,
  startDate: string | null,
  endDate: string | null
): Promise<any> => {
  return axios
    .post<any>(`/image/updateDayOrNightHistorical/${samplingPoint}`, {
      fromDate: startDate,
      toDate: endDate,
    })
    .then(responseHandlerDefault);
};

export const saveImageCropConfiguration = (payload: {
  samplingPointId: number;
  stationId: number | null;
  camera: string;
  x: number;
  y: number;
  width: number;
  height: number;
  imagePath?: string;
}): Promise<any> => {
  return axios.post(`/image/crop`, payload).then(responseHandlerDefault);
};

export const getStationImageCrop = (payload: { stationId: number | null }): Promise<any> => {
  return axios.post(`/image/stationCrop`, payload).then(responseHandlerDefault);
};
